import { Typography } from '@execonline-inc/execonline-ui';
import { whenZero } from '@execonline-inc/numbers';
import { observer } from 'mobx-react';
import EmptyKeyMetrics from '../../../EmptyComponents/EmptyKeyMetrics';
import Card from './Card';
import { KeyMetricsPayload, KeyMetricsTitle } from './Decoder';

interface Props {
  keyMetrics: KeyMetricsPayload;
  title: KeyMetricsTitle;
}

function EmptyDataCheck({ title, keyMetrics }: Props) {
  const {
    activeProductLicensesAvailable,
    activeParticipants,
    pfCountUnderActiveProductLicenses,
    pfCountWithStudentCourseReg,
    productLicensesPurchased,
  } = keyMetrics;
  switch (title) {
    case 'Active Participants':
      return whenZero(activeParticipants)
        .map(() => <EmptyKeyMetrics />)
        .getOrElse(() => (
          <Typography variant="h4" fontWeight="bold" className="mr-[4%]" color="dark">
            {activeParticipants}
          </Typography>
        ));
    case 'Activated Licenses':
      return (
        <Card numerator={activeProductLicensesAvailable} denominator={productLicensesPurchased} />
      );
    case 'Programs In Use':
      return (
        <Card
          numerator={pfCountWithStudentCourseReg}
          denominator={pfCountUnderActiveProductLicenses}
        />
      );
  }
}

export default observer(EmptyDataCheck);
